import React from 'react';

import { flagStyles } from '../settings';

const SvgQA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4440px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgQA;
